module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-container"
  }, [_c('div', {
    staticClass: "main-container clearfix"
  }, [_c('form', {
    staticClass: "form-custom clearfix",
    attrs: {
      "novalidate": "novalidate"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitHandler($event)
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback",
    class: {
      'has-success': (_vm.checkPhone != null) && _vm.checkPhone, 'has-error': (_vm.checkPhone != null) && !_vm.checkPhone
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("手机号")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "11",
      "placeholder": "请输入手机号"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "blur": _vm.validatePhone,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkPhone != null),
      expression: "checkPhone != null"
    }],
    staticClass: "glyphicon form-control-feedback",
    class: {
      'glyphicon-ok': _vm.checkPhone, 'glyphicon-remove': !_vm.checkPhone
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.phoneMsg))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback",
    class: {
      'has-success': (_vm.checkPassword != null) && _vm.checkPassword, 'has-error': (_vm.checkPassword != null) && !_vm.checkPassword
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("密码")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "请输入登录密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "blur": _vm.validatePassword,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkPassword != null),
      expression: "checkPassword != null"
    }],
    staticClass: "glyphicon form-control-feedback",
    class: {
      'glyphicon-ok': _vm.checkPassword, 'glyphicon-remove': !_vm.checkPassword
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.passwordMsg))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group capt-box has-feedback",
    class: {
      'has-success': (_vm.checkCaptText != null) && _vm.checkCaptText, 'has-error': (_vm.checkCaptText != null) && !_vm.checkCaptText
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("验证码")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.captText),
      expression: "captText"
    }],
    staticClass: "form-control input-capt",
    attrs: {
      "type": "text",
      "maxlength": "4",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.captText)
    },
    on: {
      "blur": _vm.validateCapt,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.captText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkCaptText != null),
      expression: "checkCaptText != null"
    }],
    staticClass: "glyphicon form-control-feedback",
    class: {
      'glyphicon-ok': _vm.checkCaptText, 'glyphicon-remove': !_vm.checkCaptText
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.captTextMsg))]), _vm._v(" "), _c('div', {
    staticClass: "capt"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;",
      "title": "点击更换验证码"
    },
    on: {
      "click": _vm.updateCapt
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.captUrl
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group mobile-code-box has-feedback",
    class: {
      'has-success': (_vm.checkPhoneCapt != null) && _vm.checkPhoneCapt, 'has-error': (_vm.checkPhoneCapt != null) && !_vm.checkPhoneCapt
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("短信验证码")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneCapt),
      expression: "phoneCapt"
    }],
    staticClass: "form-control input-mobile-code",
    attrs: {
      "type": "text",
      "maxlength": "6",
      "placeholder": "请输入短信验证码"
    },
    domProps: {
      "value": (_vm.phoneCapt)
    },
    on: {
      "blur": _vm.validatePhoneCapt,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phoneCapt = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkPhoneCapt != null),
      expression: "checkPhoneCapt != null"
    }],
    staticClass: "glyphicon form-control-feedback",
    class: {
      'glyphicon-ok': _vm.checkPhoneCapt, 'glyphicon-remove': !_vm.checkPhoneCapt
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.phoneCaptMsg))]), _vm._v(" "), _c('div', {
    staticClass: "mobile-code"
  }, [_c('button', {
    staticClass: "btn-code",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.getPhoneCapt
    }
  }, [_vm._v(_vm._s(_vm.text))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group btn-wrap"
  }, [_vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "err-wrap"
  }, [_c('span', [_vm._v(_vm._s(_vm.errmsg))]), _vm._v(" ")]), _vm._v(" "), _c('span', {
    staticClass: "protocol"
  }, [_vm._v("我接受\n          "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.show = true
      }
    }
  }, [_vm._v("《注册协议》")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group btn-wrap"
  }, [_c('button', {
    staticClass: "btn btn-login",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toLogin
    }
  }, [_vm._v("已有账号 去登录")])])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('modal', {
    staticClass: "protocol-dialog",
    attrs: {
      "show": _vm.show
    },
    on: {
      "dismiss": function($event) {
        _vm.show = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrap",
    staticStyle: {
      "width": "1140px",
      "padding": "20px 20px 0"
    }
  }, [_c('h1', {
    staticClass: "text-center",
    staticStyle: {
      "margin-top": "0px",
      "margin-bottom": "20px",
      "font-size": "28px",
      "font-weight": "normal"
    }
  }, [_vm._v("注册协议")]), _vm._v(" "), _c('iframe', {
    ref: "frame",
    staticStyle: {
      "width": "100%",
      "min-height": "300px",
      "overflow": "auto"
    },
    style: ({
      height: _vm.viewHeight + 'px'
    }),
    attrs: {
      "src": "/xieyi/yh.jsp",
      "frameborder": "0",
      "scrolling": "yes"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "padding": "12px 30px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_vm._v("同意协议")])])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-title"
  }, [_c('h1', [_vm._v("注册"), _c('span', {
    staticClass: "square"
  }, [_vm._v("REGISTER")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("注册"), _c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copy"
  }, [_vm._v("\n      © 2017 "), _c('span', [_vm._v("北京伟嘉安捷投资担保有限公司")]), _vm._v(" All rights reserved   |   京ICP备16040229号-2\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-52c55337"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/register.vue
// module id = 603
// module chunks = 1